const mockTextContent = {
  body: 'PeachyLoans: We’ve received your $57.46 payment. Thank you!',
  from: '+16088798441',
  from_name: 'PeachyLoans',
  to: '+15656565656',
}

export default mockTextContent
